/**
 * Client-side password policy hints.
 *
 * IMPORTANT: these are HINTS ONLY to help the user. The Node backend enforces the
 * authoritative policy (min 8 / max 64 / letter+digit / not all-whitespace) and is
 * the only trusted validator. Keep these thresholds in sync with the backend.
 */
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 64

export interface PolicyChecks {
  /** Length within [min, max]. */
  length: boolean
  /** Contains at least one letter (A-Z / a-z). */
  letter: boolean
  /** Contains at least one digit (0-9). */
  digit: boolean
  /** Not empty and not entirely whitespace. */
  notBlank: boolean
}

export function checkPassword(password: string): PolicyChecks {
  return {
    length:
      password.length >= PASSWORD_MIN_LENGTH &&
      password.length <= PASSWORD_MAX_LENGTH,
    letter: /[A-Za-z]/.test(password),
    digit: /[0-9]/.test(password),
    notBlank: password.length > 0 && password.trim().length > 0,
  }
}

export function isPasswordValid(password: string): boolean {
  const c = checkPassword(password)
  return c.length && c.letter && c.digit && c.notBlank
}
